import $ from '../vendor/jquery';

  $(".header-nav-primary > ol > li.nav-item--has-children > a, .header-nav-aux > ul > li.nav-item--has-children > a").each(function() {
    $(this).after('<button class="is-vishidden"><span class="vishidden">show submenu</span></button>');
  });
  $(".off-canvas-nav > ol > li.nav-item--has-children > a").each(function() {
    $(this).after('<button class="is-vishidden"><span class="vishidden">show submenu</span></button>');
  });

  $("li.nav-item--has-children button").click(function(event) {
    if (!$(this).parents('li').hasClass("open")) {
      $(this).parents('li').addClass("open");
      this.parentNode.setAttribute('aria-expanded', "true");
      this.querySelector('.vishidden').innerText = 'hide submenu';
    } else {
      $(this).parents('li').removeClass("open");
      this.parentNode.setAttribute('aria-expanded', "false");
      this.querySelector('.vishidden').innerText = 'show submenu';
    }
    event.preventDefault();
    
  });



//Making the menu accessible
  // var menuItems = document.querySelectorAll('li.nav-item--has-children');
  // Array.prototype.forEach.call(menuItems, function(el, i){
  // 	var btn = '<button class="is-vishidden"><span class="vishidden">show submenu</span></button>';
  //   var topLevelLink = el.querySelector('a');
  //   $('.header-nav-primary > ol > li.nav-item--has-children > a').append(btn);
  // 	//topLevelLink.innerHTML = topLevelLink.innerHTML + ' ' + btn;

  // 	el.querySelector('a button').addEventListener("click",  function(event){
  // 		
  // 	});
  // });

  //THIS IS FOR IF YOU DON'T NEED THE FIRST LI TO BE LINKED TO AN ACTUAL PAGE
  // var menuItems2 = document.querySelectorAll('li.nav-item--has-children');
  // Array.prototype.forEach.call(menuItems2, function(el, i){
  // 	el.querySelector('a').addEventListener("click",  function(event){
  // 		if (this.parentNode.className == "nav-item--has-children") {
  // 			this.parentNode.className = "nav-item--has-children open";
  // 			this.setAttribute('aria-expanded', "true");
  // 		} else {
  // 			this.parentNode.className = "nav-item--has-children";
  // 			this.setAttribute('aria-expanded', "false");
  // 		}
  // 		event.preventDefault();
  // 		return false;
  // 	});
  // });



// WEBPACK FOOTER //
// ./public/assets/js/src/components/menu-accessibility.js